const adalDev = {
    applicationId: '7ecec07f-8763-4e39-bd60-cb066e943b52',
    localhostUri: 'http://' + window.location.host
};

const socketioDev = {
    url: 'http://' + window.location.host
};

const adalProd = {
    applicationId: '7ecec07f-8763-4e39-bd60-cb066e943b52',
    localhostUri: 'https://' + window.location.host
};

const socketioProd = {
    url: 'https://' + window.location.host
};

// Azure test environment
const adal = (process.env.NODE_ENV === 'development' ? adalDev : adalProd);
const socketio = (process.env.NODE_ENV === 'development' ? socketioDev : socketioProd);
const appInsightsInstKey = (process.env.NODE_ENV === 'development' ? '' : 'b54a2526-56ae-49d2-a056-fe339e5a4706');

const ftpAgent_EDP = 'EDPG';
module.exports = {
    adal,
    socketio,
    appInsightsInstKey,
    ftpAgent_EDP
};



// WEBPACK FOOTER //
// ./src/env/environment.js